export const cssSupport = (conditionText: string) => {
  if (typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false
  return CSS.supports(conditionText)
}
